module.exports = "/_next/static/images/2-693b86b82c2673c5087cb92701d7be01.jpg";